import React, { useEffect, useState } from "react";
import DashboardHeader from "../../../Components/header/DashboardHeader";
import "./CreateFeeds.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Input,
  LoadingButton,
  TextArea,
} from "../../../Components/header/form";
import {
  imageHandler,
  multipleImageHandler,
} from "../../../utils/imageHandler";
import { edit_icon, img_placehlder, upload_cover } from "../../../assets";
import multipartDataHelper, {
  printFormData,
} from "../../../utils/sendMultipartDataHelper";
import { toastMessage } from "../../../utils/toastMessage";
import {
  createFeedApi,
  feedDetailApi,
  updateFeedApi,
} from "../../../services/feeds";
import Slider from "react-slick";
import { RxCross2 } from "react-icons/rx";
import { FaArrowLeft, FaPlusCircle } from "react-icons/fa";
import { uploadAttachmentApi } from "../../../services/message";

const EditFeeds = () => {
  const { feedId } = useParams();
  const [loading, setLoading] = useState(false);
  const [inputData, setInputData] = useState({
    _id: feedId,
    title: "",
  });
  const [image, setImage] = useState([]);
  const navigate = useNavigate();
  //-----------handle-change---------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };
  //------------remove-image--------------
  const removeImageHandler = (_id) => {
    const filteredImages = image?.filter((img) => img._id !== _id);
    setImage(filteredImages);
  };

  //-----------image-create-url---------------
  const handleFileChange = async (event) => {
    const files = event.target.files;
    if (!files.length) {
      return toastMessage("Please upload an image", "error", "selectMedia");
    }
    const uploadedImages = [];

    for (const file of files) {
      const formData = new FormData();
      formData.append("attachments", file);

      try {
        const { data } = await uploadAttachmentApi(formData);
        const { success, message, data: res } = data;
        // console.log('res', res)
        if (success && res?.length) {
          uploadedImages.push({
            size: res[0]?.size,
            url: res[0]?.key,
            type: "IMAGE",
            showUrl: res[0]?.url,
          });
        }else{
          toastMessage(message, success ? "success" : "error", "addGroupHandler");
        }
      } catch (e) {
        console.log("Error:-", e.message);
      }
    }

    setImage((prevImages) => [...prevImages, ...uploadedImages]);
  };
  // Getting Feed Detail
  const getFeedDetail = async () => {
    try {
      const { data } = await feedDetailApi({ _id: feedId });
      const { success, message, data: response } = data;

      if (success) {
        // console.log(response, "Response");
        setInputData({
          categoryName: response?.categoryName,
          _id: feedId,
          // type: response?.type,
          title: response?.title,
          description: response?.description,
        });

        setImage(response?.attachments);
      } else {
        toastMessage(message, "error", "getFeedDetail");
      }
    } catch (e) {
      console.error("Error:-", e.message);
    }
  };

  const editFeedHandler = async () => {
    try {
      setLoading(true);
      const formData = {
        ...inputData,
        attachments: image.map((data) => ({
          type: "IMAGE",
          size: data?.size || 0,
          url: data?.url.startsWith("logical_chat/")
            ? data?.url
            : `logical_chat/${data?.url.split("/").pop()}`,
        })),
      };
      const { data } = await updateFeedApi(formData);
      const { success, message } = data;
      if (success) {
        navigate(-1);
      }
      toastMessage(message, success ? "success" : "error", "editFeedHandler");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFeedDetail();
  }, []);
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
  return (
    <>
      <div className="create_group">
        <DashboardHeader title={"Groups"} />

        <div className="create_group_page">
          <div className="create_grp_Navbar">
            <nav>
              <ul className="_breadcrumb _breadcrumb_two">
                <div className="breadcrumb_lft">
                  <li className="__breadcrumb_group">
                    <Link to={-1} className="active">
                      <FaArrowLeft className="backarrow_grp_detail" />
                    </Link>
                  </li>

                  <li>
                    <span>Update Feed</span>
                  </li>
                </div>

                {image.length > 0 && (
                  <label className="plus_icon" htmlFor="file_picker">
                    <FaPlusCircle />
                  </label>)}
              </ul>
            </nav>
          </div>

          <div className="upload_cover upload_cover_two">
            <div className="slider_banner">
              <Slider {...settings}>
                {image &&
                  image?.length > 0 &&
                  image?.map((data, ind) => (
                    // <div key={ind} className="_breadcrumbpload_design_content ">
                    <div key={ind} className="upload_design_content">
                      <img
                        src={data?.showUrl || data?.url || upload_cover}
                        alt="Uploaded"
                      />
                      <RxCross2
                        onClick={() => removeImageHandler(data?._id)}
                        className="cross_btn"
                      />
                    </div>
                  ))}
              </Slider>
            </div>
            <div className="upload_design">
              <label className="user_icon" htmlFor="file_picker">
                {image.length === 0 && (
                  <div className="upload_design_content">
                    <div className="upload_design_text">
                      <h3>Upload Cover</h3>
                      <p>(JPG, GIF, PNG. Max size of 800K)</p>
                    </div>
                  </div>)}
                <input
                  type="file"
                  id="file_picker"
                  accept="image/*"
                  multiple
                  onChange={handleFileChange}
                />
                <label htmlFor="profile_picture" className="edit-icon"></label>
              </label>
            </div>
            <div className="form-group form-group-top">
              <Input
                required
                label="Group Name"
                type="text"
                id="title"
                name="title"
                value={inputData?.title}
                onChange={handleChange}
                className="input form-control"
                placeholder="Enter Title"
              />
            </div>

            <div className="form-group textarea">
              <TextArea
                required
                label="Description"
                type="text"
                id="description"
                name="description"
                disabled
                value={inputData?.description}
                onChange={handleChange}
                className="input form-control"
                placeholder="Write here..."
                rows="6"
              />
            </div>
          </div>

          <LoadingButton loading={loading} onClick={editFeedHandler}>
            Update Feed
          </LoadingButton>
        </div>
      </div>
    </>
  );
};

export default EditFeeds;
